import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'
import {fonts} from '../../theme/foundations/fonts'

const {lg} = sizes.container

export const contentStyle = {
    position: 'relative',
    backgroundColor: 'cav_black',
    clear: 'both',
    letterSpacing: pxToRem(1),
    height: '100%',
    '.footer-container': {
        // checkbox has default class that was used to toggle in SFRA imprementation
        '.default': {
            display: 'none'
        },
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        width: '100%',
        boxSizing: 'border-box',
        '#footer-emailsignup-socialicons': {
            gridColumn: '1 /  span 4',
            gridRow: '2',
            '.content-asset': {
                width: '100%',
                '.social-share-icons': {
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: pxToRem(50),
                    gap: pxToRem(50)
                }
            }
        },
        '#footer-copy': {
            gridColumn: '1 /  span 4',
            gridRow: '3'
        },
        paddding: `${pxToRem(8)} ${pxToRem(25)} ${pxToRem(40)} ${pxToRem(25)}`,
        maxWidth: pxToRem(1450),
        margin: '0 auto',
        '.content-asset': {
            padding: pxToRem(20),
            p: {
                lineHeight: pxToRem(31),
                fontSize: pxToRem(16),
                fontFamily: fonts.secondary,
                color: 'cav_deep_light_gray',
                marginLeft: pxToRem(17),
                marginTop: pxToRem(-7),
                letterSpacing: pxToRem(4),
                [`@media (max-width: ${lg})`]: {
                    marginLeft: 0
                }
            },
            span: {
                [`@media (max-width: ${lg})`]: {
                    fontSize: pxToRem(14)
                }
            }
        },
        'h2, h3': {
            textTransform: 'uppercase',
            fontFamily: fonts.primary,
            fontSize: pxToRem(20),
            fontWeight: 'bold',
            color: 'cav_clay',
            paddingBottom: '0',
            letterSpacing: pxToRem(4),
            lineHeight: pxToRem(34),
            margin: `${pxToRem(20)} 0`,
            [`@media (max-width: ${lg})`]: {
                fontSize: pxToRem(15)
            }
        },
        '.menu-footer': {
            float: 'none',
            margin: `${pxToRem(-5)} 0 0 ${pxToRem(17)}`,
            padding: '0',
            li: {
                float: 'none',
                listStyle: 'none'
            },
            [`@media (max-width: ${lg})`]: {
                margin: 0
            }
        },
        a: {
            color: 'cav_deep_light_gray',
            fontSize: pxToRem(16),
            letterSpacing: pxToRem(4),
            lineHeight: pxToRem(30),
            textDecoration: 'none',
            fontFamily: fonts.secondary,
            '&:hover': {
                color: 'cav_hover_brightred'
            },
            [`@media (max-width: ${lg})`]: {
                fontSize: pxToRem(14)
            }
        },
        '.copyright': {
            color: 'cav_deep_light_gray',
            fontFamily: fonts.secondary,
            textAlign: 'center',
            padding: `${pxToRem(50)} 0 0 0`,
            fontSize: pxToRem(16),
            letterSpacing: pxToRem(1.6),
            a: {
                padding: '0',
                textDecoration: 'none',
                textTransform: 'uppercase',
                fontSize: pxToRem(16),
                [`@media (max-width: ${lg})`]: {
                    fontSize: pxToRem(12)
                }
            },
            [`@media (max-width: ${lg})`]: {
                fontSize: pxToRem(12)
            },
            '.pipe-seperator': {
                display: 'inline-block',
                padding: `0 ${pxToRem(20)}`,
                [`@media (max-width: ${lg})`]: {
                    padding: `0 ${pxToRem(10)}`
                }
            }
        }
    },

    // Mobile screen
    '.footer-container-mobile': {
        display: 'block',
        width: '100%',
        boxSizing: 'border-box',
        padding: `${pxToRem(15)} ${pxToRem(10)} ${pxToRem(15)} ${pxToRem(20)}`,
        '.accordion-item': {
            border: 'none'
        },
        '.accordion-header': {
            '.accordion-header-text': {
                marginBottom: pxToRem(5),
                padding: `${pxToRem(5)} 0`,
                height: pxToRem(34),
                textTransform: 'uppercase',
                fontFamily: fonts.primary,
                fontSize: pxToRem(20),
                fontWeight: 'bold',
                color: 'cav_clay',
                paddingBottom: '0',
                letterSpacing: pxToRem(4),
                position: 'relative',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '.accordion-header-btn': {
                    position: 'static',
                    fontSize: pxToRem(30),
                    textAlign: 'center',
                    width: pxToRem(30),
                    paddingTop: pxToRem(15)
                }
            }
        },
        '.accordion-panel-content': {
            padding: '0',
            margin: '0',
            fontFamily: fonts.secondary,
            fontSize: pxToRem(16),
            color: 'cav_deep_light_gray',
            lineHeight: pxToRem(31),
            letterSpacing: pxToRem(4),
            'ul, .customer-service-content': {
                float: 'none',
                margin: `${pxToRem(-5)} 0 0 ${pxToRem(20)}`,
                padding: '0',
                a: {
                    color: 'cav_deep_light_gray',
                    fontSize: pxToRem(16),
                    letterSpacing: pxToRem(4),
                    lineHeight: pxToRem(30),
                    textDecoration: 'none',
                    '&:hover': {
                        color: 'cav_hover_brightred'
                    }
                }
            },
            li: {
                listStyle: 'none',
                float: 'none'
            }
        },
        '.static-content': {
            '.content-asset': {
                width: '100%',
                '.social-share-icons': {
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: pxToRem(50),
                    gap: pxToRem(10)
                }
            },
            '.copyright': {
                color: 'cav_deep_light_gray',
                fontFamily: fonts.secondary,
                textAlign: 'center',
                padding: `${pxToRem(50)} 0 0 0`,
                fontSize: pxToRem(12),
                letterSpacing: pxToRem(1),
                a: {
                    padding: '0',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    fontSize: pxToRem(11),
                    lineHeight: pxToRem(23),
                    color: 'cav_deep_light_gray',
                    '&:hover': {
                        color: 'cav_hover_brightred'
                    }
                },
                '.copy-inner': {
                    display: 'block'
                },
                '.pipe-seperator': {
                    display: 'inline-block',
                    padding: `0 ${pxToRem(15)}`
                },
                span: {
                    display: 'inline-block',
                    lineHeight: pxToRem(23),
                    textAlign: 'center'
                },
                'span+span': {
                    display: 'none !important'
                }
            }
        }
    }
}
